<template>
  <div class="layout-main">
    <layout-nav></layout-nav>
    <layout-alert></layout-alert>
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Nav from "@/components/Nav";
import Alert from "@/components/Alert";

export default {
  name: "Home",
  components: {
    "layout-nav": Nav,
    "layout-alert": Alert
  },
  computed: {
    appName() {
      return this.$store.state.appName;
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/main";
</style>
